import { useLocalStorage } from "@rehooks/local-storage";

export type NativeBridgeType = "DEFAULT_WEB" | "MLBAM_BALLPARK_NATIVE";

const NATIVE_BRIDGE_LOCAL_STORAGE_KEY = "NativeBridge";

const KNOWN_BRIDGES: ReadonlySet<string> = new Set<NativeBridgeType>([
  "DEFAULT_WEB",
  "MLBAM_BALLPARK_NATIVE",
]);

function isKnownBridge(value: unknown): value is NativeBridgeType {
  return typeof value === "string" && KNOWN_BRIDGES.has(value);
}

export function useSetNativeBridge() {
  const [_bridge, setNativeBridge] = useLocalStorage<NativeBridgeType>(
    NATIVE_BRIDGE_LOCAL_STORAGE_KEY,
    "DEFAULT_WEB",
  );

  return setNativeBridge;
}

export function useNativeBridge(): NativeBridgeType {
  const [bridge] = useLocalStorage<NativeBridgeType>(
    NATIVE_BRIDGE_LOCAL_STORAGE_KEY,
    "DEFAULT_WEB",
  );

  return isKnownBridge(bridge) ? bridge : "DEFAULT_WEB";
}
